import React from 'react';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH5 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH3', value });
  return (
    <h5 className={className} style={style}>
      {children}
    </h5>
  );
};

RichTextH5.dispayName = 'RichTextH5';

export default RichTextH5;
